import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CategoryHeader from "./CategoryHeader";
import Articles from "./Articles";
import BackBtn from "./BackBtn";

function Category(props) {
  const articleId = useParams();
  const [categoryName, setCategoryName] = useState(0);
  const [categoryIndex, setCategoryIndex] = useState(0);
  const fetchCategories = props.data.content.categories;
  const fetchArticles = props.data.content.articles;

  const categoryColor = fetchCategories
    .filter((post) => post.category == categoryName)
    .map((post) => post.color);

  const testUrl = window.location.href;

  useEffect(() => {
    setCategoryName(articleId.category);
    setCategoryIndex(
      fetchCategories.find((post) => post.category == categoryName)
    );
    document.body.className = "search-shrink";
    return () => {
      document.body.className = "";
    };
  }, [categoryIndex]);

  return (
    <section className="category">
      <BackBtn />
      <ul className="breadcrumbs">
        <li>
          <Link to="/">{props.data.settings.site}</Link>
        </li>
        <li>
          {fetchCategories
            .filter((post) => post.category == categoryName)
            .map((post) => post.category)}
        </li>
      </ul>

      <CategoryHeader
        title={fetchCategories
          .filter((post) => post.category == categoryName)
          .map((post) => post.title)}
        description={fetchCategories
          .filter((post) => post.category == categoryName)
          .map((post) => post.text)}
        icon={`${fetchCategories
          .filter((post) => post.category == categoryName)
          .map((post) => post.svg)}`}
        alt={fetchCategories
          .filter((post) => post.category == categoryName)
          .map((post) => post.title)}
        color={fetchCategories
          .filter((post) => post.category == categoryName)
          .map((post) => post.color)}
      />

      {/* <div className="content-split">
        <div className="sidebar">
          {categoryIndex == null ? (
            "Loading..."
          ) : categoryIndex.subcategories?.length < 1 ? (
            ""
          ) : (
            <ul>
              {categoryIndex.subcategories?.map((post) => (
                <li key={post.id}>
                  <Link to={`${post.category}`}>{post.title}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="content">
          <ul className="listArticles">
            {fetchArticles
              .filter(
                (post) =>
                  post.categoryId ==
                    fetchCategories[post.categoryId].id &&
                  fetchCategories[post.categoryId].category ==
                    categoryName
              )
              .map((post) => (
                <li key={post.id}>
                  <Link to={`/article/${post.url}/${post.id}`}>
                    {post.question}
                  </Link>

                  {fetchCategories[post.categoryId].subcategories[
                    post.subcategoryId
                  ] ? (
                    <span className="badge">
                      {
                        fetchCategories[post.categoryId]
                          .subcategories[post.subcategoryId]?.title
                      }
                    </span>
                  ) : (
                    <span className="badge warning">Uncategorized</span>
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div> */}

      <div className="category-subcategories">
        <span
          className="category-subcategoriesBar"
          style={{
            backgroundColor: `${categoryColor}`,
          }}
        ></span>
        {categoryIndex == null ? (
          "Loading..."
        ) : categoryIndex.subcategories?.length < 1 ? (
          "No articles found..."
        ) : (
          <>
            {categoryIndex.subcategories?.map((subcategory) => (
              <div
                key={subcategory.id}
                className="category-subcategories-category"
              >
                <Link
                  to={`${subcategory.category}`}
                  className="title"
                  style={{
                    color: `${categoryColor}`,
                  }}
                >
                  {subcategory.title}
                </Link>

                {/* show faq articles in category */}
                {testUrl.indexOf("faq") > -1 ? (
                  <Articles
                    data={props}
                    title=""
                    subtitle=""
                    featured={true}
                    limit={20}
                    showCategory={true}
                  />
                ) : (
                  ""
                )}

                <ul className="listArticles">
                  {fetchArticles
                    .filter(
                      (article) =>
                        article.categoryId ==
                          fetchCategories[article.categoryId].id &&
                        fetchCategories[article.categoryId].category ==
                          categoryName &&
                        article.subcategoryId == subcategory.id
                    )
                    .map((article) => (
                      <li key={article.id} data-color={categoryColor}>
                        <Link to={`/article/${article.url}/${article.id}`}>
                          {article.question}
                        </Link>

                        {/* {fetchCategories[article.categoryId]
                          .subcategories[article.subcategoryId] ? (
                          <span className="badge">
                            {
                              fetchCategories[article.categoryId]
                                .subcategories[article.subcategoryId]?.title
                            }
                          </span>
                        ) : (
                          <span className="badge warning">Uncategorized</span>
                        )} */}
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </>
        )}
      </div>
    </section>
  );
}

export default Category;
